import sx from 'utils/createSx';

export const DIALOG_PAPER_SLOT = {
  sx: {
    maxWidth: '100%',
    overflow: 'hidden',
  },
};

export default sx({
  dialogTitle: { pr: 1 },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
  },
  titleTypography: { fontWeight: 600 },
  dialogContent: {
    pt: 2,
    overflowX: 'hidden',
    overflowY: 'auto',
    maxWidth: '100%',
  },
  overlineBlock: { display: 'block' },
  dateValue: { fontWeight: 600 },
  reportBody: { whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
  imageList: {
    width: '100%',
    maxWidth: '100%',
    m: 0,
    overflow: 'hidden',
  },
  imageListItem: { borderRadius: 1, overflow: 'hidden' },
});
